import { Subject } from 'rxjs';

export class ModalRef<T = any> {
  readonly onClose: Subject<any> = new Subject<any>();
  private _closeFn!: (value?: any) => void;

  /** @internal — called by ModalService */
  _setCloseFn(fn: (value?: any) => void): void {
    this._closeFn = fn;
  }

  close(value?: any): void {
    this._closeFn(value);
  }
}
